import React from "react"

const VideoPreview = ({ videoReview, className = "" }) => {
  if (!videoReview) return null

  // Get booking count for the client
  const bookingCount =
    videoReview.client?.appointments?.filter(
      (appointment) => appointment.state === "approved" || appointment.state === 2 // approved appointments (handle both string and numeric)
    )?.length || 0

  return (
    <div className={`relative h-[400px] w-[224px] ${className}`}>
      {/* Video container */}
      <div className="absolute bottom-0 left-1/2 h-[400px] w-[224px] translate-x-[-50%]">
        {videoReview.video_url || videoReview.videoUrl ? (
          <video
            className="pointer-events-none absolute inset-0 size-full max-w-none object-cover"
            src={videoReview.video_url || videoReview.videoUrl}
            muted
            loop
            playsInline
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-200">
            <i className="icon-film text-4xl text-gray-400" />
          </div>
        )}
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-[rgba(0,0,0,0.3)]" />
      </div>

      {/* Overlays */}
      <div className="absolute bottom-0 left-0 h-[400px] w-[224px] text-clip">
        {/* Bottom gradient overlay with content */}
        <div className="absolute bottom-0 left-0 box-border flex w-[224px] content-stretch items-end gap-[8px] bg-gradient-to-b from-[rgba(0,0,0,0)] to-[rgba(0,0,0,0.7)] px-[16px] pb-[16px] pt-[32px]">
          <div className="relative flex min-h-px min-w-px flex-[1_0_0] shrink-0 flex-col content-stretch items-start gap-[8px]">
            {/* Name + Stars */}
            <div className="relative flex w-[192px] shrink-0 flex-col content-stretch items-start gap-[4px]">
              <div className="text-sm font-normal text-white">{videoReview.client?.name || "Anonymous"}</div>
              {/* Star rating - you can implement this based on your rating system */}
              <div className="relative flex shrink-0 content-stretch items-start gap-[2px]">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="relative size-[16px] shrink-0">
                    <i className="icon-star text-xs text-yellow-400" />
                  </div>
                ))}
              </div>
            </div>
            {/* Date */}
            <div className="w-[192px] text-xs font-semibold uppercase tracking-wider text-white">
              {videoReview.recorded_at
                ? new Date(videoReview.recorded_at).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric"
                  })
                : new Date(videoReview.created_at).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric"
                  })}
            </div>
          </div>
          {/* Volume button */}
          <button className="relative block size-[20px] shrink-0 cursor-pointer text-clip">
            <i className="icon-volume-off text-sm text-white" />
          </button>
        </div>
      </div>

      {/* BOOKED X TIMES overlay tag */}
      {bookingCount > 1 && (
        <div className="absolute left-[10px] top-[10px] z-10 box-border flex content-stretch items-center justify-center gap-[8px] text-clip rounded-[4px] bg-red-500 px-[12px] py-[4px]">
          <div className="relative flex shrink-0 flex-col justify-center whitespace-nowrap text-xs font-semibold uppercase leading-[0] tracking-wider text-white">
            <p className="leading-4">
              Booked {bookingCount} time{bookingCount !== 1 ? "s" : ""}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default VideoPreview
